"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var basicTheme = require("../basicForm/theme.scss");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var Recaptcha = require("react-recaptcha");
var LoginLink = function (_a) {
    var onLogin = _a.onLogin;
    return (React.createElement("div", { className: basicTheme.footerLink },
        "Return to ",
        React.createElement("a", { onClick: onLogin }, "sign in")));
};
var ForgotPasswordForm = /** @class */ (function (_super) {
    tslib_1.__extends(ForgotPasswordForm, _super);
    function ForgotPasswordForm(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onForgotPassword = function (e) {
            e.preventDefault();
            var onForgotPassword = _this.props.onForgotPassword;
            var _a = _this.state, email = _a.email, token = _a.token;
            onForgotPassword(email, token);
        };
        _this.onInputChange = function (e) {
            var key = e.target.name;
            var nextState = {};
            nextState[key] = e.target.value;
            _this.setState(nextState);
        };
        _this.onVerify = function (token) {
            _this.setState({
                isNotARobot: true,
                token: token
            });
        };
        _this.onExpire = function () {
            _this.setState({
                isNotARobot: false
            });
        };
        _this.state = { email: props.withEmail, token: "", isNotARobot: false };
        return _this;
    }
    ForgotPasswordForm.prototype.renderForm = function () {
        var _a = this.props, error = _a.error, onLoginClick = _a.onLoginClick, siteKey = _a.siteKey, title = _a.title;
        var _b = this.state, email = _b.email, isNotARobot = _b.isNotARobot;
        return (React.createElement("div", { className: basicTheme.container },
            React.createElement("div", { className: basicTheme.label }, title),
            React.createElement("form", { onSubmit: this.onForgotPassword, className: basicTheme.form },
                React.createElement(ui_1.FormInput, { value: email, onChange: this.onInputChange, name: "email", className: theme.email, label: "email", required: true, fill: true, type: "email", autoFocus: true }),
                React.createElement("div", { className: theme.recaptcha },
                    React.createElement(Recaptcha, { sitekey: siteKey, size: "normal", render: "explicit", theme: "light", verifyCallback: this.onVerify, onloadCallback: function () { }, expiredCallback: this.onExpire })),
                React.createElement(ui_1.Button, { disabled: !isNotARobot, className: basicTheme.button, type: "submit", blue: true, uppercase: true, fill: true, large: true }, "Reset Password")),
            error ? (React.createElement("div", { className: basicTheme.error }, "Something went wrong.")) : null,
            React.createElement(LoginLink, { onLogin: onLoginClick })));
    };
    ForgotPasswordForm.prototype.renderCompleteMessage = function () {
        var onLoginClick = this.props.onLoginClick;
        var email = this.state.email;
        return (React.createElement("div", { className: basicTheme.container },
            React.createElement(ui_1.Icon, { iconName: "icon-email", size: 6, className: theme.icon }),
            React.createElement("div", { className: basicTheme.label + " " + theme.label }, "Check your email"),
            React.createElement("div", { className: theme.message },
                React.createElement("div", null, "A Reset password link was sent to your email"),
                React.createElement("div", null,
                    "\"",
                    email,
                    "\"")),
            React.createElement(LoginLink, { onLogin: onLoginClick })));
    };
    ForgotPasswordForm.prototype.renderLoader = function () {
        return (React.createElement("div", { className: basicTheme.container },
            React.createElement(ui_1.CircleLoader, { blue: true, size: 4 })));
    };
    ForgotPasswordForm.prototype.render = function () {
        var _a = this.props, isComplete = _a.isComplete, isLoading = _a.isLoading;
        return isLoading
            ? this.renderLoader()
            : isComplete
                ? this.renderCompleteMessage()
                : this.renderForm();
    };
    ForgotPasswordForm.defaultProps = {
        title: "Forgot your password?"
    };
    return ForgotPasswordForm;
}(React.Component));
exports.default = ForgotPasswordForm;
